import { useCallback, useEffect, useState } from "react";
import { isAuthenticated } from "../../auth";
import { listSellerProviderLinks } from "../services/providerProductService";

const idOf = (value) => value?._id || (typeof value === "string" ? value : null);

const useMyLinkedProviderProductIds = () => {
  const [linkedProductIds, setLinkedProductIds] = useState(new Set());
  const [linkedProviderIds, setLinkedProviderIds] = useState(new Set());
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState("");
  const [version, setVersion] = useState(0);
  const reload = useCallback(() => setVersion((value) => value + 1), []);

  useEffect(() => {
    let current = true;
    setLoaded(false);
    setError("");
    listSellerProviderLinks(isAuthenticated()?.token, { status: "active" }).then((result) => {
      if (!current) return;
      if (result?.error) setError(result.error);
      else {
        const items = Array.isArray(result?.items) ? result.items : [];
        setLinkedProductIds(new Set(items.map((link) => idOf(link.providerProductId)).filter(Boolean).map(String)));
        setLinkedProviderIds(new Set(items.map((link) => idOf(link.providerId)).filter(Boolean).map(String)));
      }
      setLoaded(true);
    });
    return () => { current = false; };
  }, [version]);

  return { linkedProductIds, linkedProviderIds, loaded, error, reload };
};

export default useMyLinkedProviderProductIds;
